import React, { useEffect, useRef, useState } from 'react';
import { Button, Table, Tooltip, message } from 'antd';   // 👈  Table remplaçe Row/Col
import { useObjectsApi } from '../../../api/objects/objects';
import { TSound } from '../../../models/objects/media';
import { getSoundPath } from '../../../utils/format/valueFormat';

const SoundsConfigurator: React.FC = () => {
    const [mediaSounds, setMediaSounds] = useState<TSound[]>([]);
    const { getSounds } = useObjectsApi();
    const previewAudioRef = useRef<HTMLAudioElement | null>(null);

    useEffect(() => {
        getSounds()
            .then((resp) => setMediaSounds(resp.data))
            .catch((err) => message.error(err.response?.data || err.message));
    }, [getSounds]);

    /** Lecture avec auto‑stop après 5 s. */
    const playSound = (sound: TSound) => {
        if (previewAudioRef.current) {
            previewAudioRef.current.pause();
            previewAudioRef.current.currentTime = 0;
        }
        const audio = new Audio(getSoundPath(sound.file_path));
        previewAudioRef.current = audio;
        audio.play();
        setTimeout(() => {
            if (previewAudioRef.current === audio) {
                audio.pause();
                audio.currentTime = 0;
                previewAudioRef.current = null;
            }
        }, 5000);
    };

    /** Colonnes minimalistes */
    const columns = [
        {
            dataIndex: 'file_name',
            render: (_: any, snd: TSound) => (
                <div style={{ maxWidth: 220 }}>
                    <strong style={{ display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {snd.file_name}
                    </strong>
                    <Tooltip title={`ID: ${snd.id}`}>
                        <small style={{ color: '#888' }}>ID : {snd.id}</small>
                    </Tooltip>
                </div>
            ),
        },
        {
            key: 'actions',
            align: 'right' as const,
            width: 90,
            render: (_: any, snd: TSound) => (
                <Button size="small" onClick={() => playSound(snd)}>
                    Play
                </Button>
            ),
        },
    ];

    return (
        <Table<TSound>
            columns={columns}
            dataSource={mediaSounds}
            rowKey="id"
            pagination={false}
            showHeader={false}
            size="small"
            bordered={false}
        />
    );
};

export default SoundsConfigurator;
